import { LinkAttachmentsProps } from 'app/components/LinkAttachments';
import { AttachmentCard } from 'types/Attachments';
import ArrayUtils from 'app/utils/array';

export function useLinkAttachmentsChange({
  onAttachmentsChange,
  onOptionsChange,
}: Pick<LinkAttachmentsProps, 'onAttachmentsChange' | 'onOptionsChange'>) {
  function addAttachmentsCard(
    card: Partial<AttachmentCard> & Pick<AttachmentCard, 'medium'>,
    keepPrevious?: boolean,
  ) {
    onAttachmentsChange(({ cards }) => {
      const firstCard: AttachmentCard | undefined = cards[0];

      const newPrefilledCard = {
        ...card,
        url: card.url || firstCard?.url || '',
        title: card.title || firstCard?.title || '',
        description: card.description || firstCard?.description || '',
        caption: card.caption || firstCard?.caption || '',
        call_to_action:
          card.call_to_action ?? firstCard?.call_to_action ?? null,
        is_original_link_media: card.is_original_link_media ?? false,
      };

      return {
        cards: [...(keepPrevious ? [...cards] : []), newPrefilledCard],
      };
    });
  }

  function updateAttachmentsCard(
    partialAttachmentCard: Partial<AttachmentCard>,
    atIndex?: number,
  ) {
    onAttachmentsChange((prev) => ({
      cards: prev.cards.map((attachment, i) => {
        if (typeof atIndex === 'number') {
          return i === atIndex
            ? { ...attachment, ...partialAttachmentCard }
            : attachment;
        }

        return { ...attachment, ...partialAttachmentCard };
      }),
    }));
  }

  function removeAttachmentCard(atIndex: number) {
    onAttachmentsChange((prev) => ({
      cards: prev.cards.filter((_, i) => i !== atIndex),
    }));
  }

  function clearAttachmentsCards() {
    onAttachmentsChange(() => ({
      cards: [],
    }));
    onOptionsChange?.({
      canAppendLinkFromText: false,
    });
  }

  function moveAttachmentIndex(oldIndex: number, newIndex: number) {
    onAttachmentsChange((prev) => ({
      cards: ArrayUtils.move(prev.cards, oldIndex, newIndex),
    }));
  }

  function setIsLinkOwnershipVerified(value: boolean) {
    onAttachmentsChange(() => ({ is_link_ownership_verified: value }));
  }

  function toggleMultiShareEndCard() {
    onAttachmentsChange(({ multi_share_end_card }) => ({
      multi_share_end_card: !multi_share_end_card,
    }));
  }

  return {
    toggleMultiShareEndCard,
    setIsLinkOwnershipVerified,
    addAttachmentsCard,
    updateAttachmentsCard,
    removeAttachmentCard,
    clearAttachmentsCards,
    moveAttachmentIndex,
  };
}
